<template>
  <div
    class="purchase-allowance"
    style="width: 100%; height: 86vh; display: flex; position: relative"
  >
    <div class="left-part">
      <div class="left-part-first">
        <div class="statistics">
          <div class="statistics-title">申请表数(份)</div>
          <div
            class="statistics-number"
            :data-content="
              numberSeparatorCompute(totalStatistics.numApplications || 0)
            "
          >
            {{
              (totalStatistics.numApplications || 0).toFixed(0)
                | toThousandFilter
            }}
          </div>
        </div>
        <div class="statistics">
          <div class="statistics-title">受益户数(户)</div>
          <div
            class="statistics-number"
            :data-content="
              numberSeparatorCompute(totalStatistics.numBeneficiaries || 0)
            "
          >
            {{
              (totalStatistics.numBeneficiaries || 0).toFixed(0)
                | toThousandFilter
            }}
          </div>
        </div>
        <div class="statistics">
          <div class="statistics-title">机具台数(台)</div>
          <div
            class="statistics-number"
            :data-content="
              numberSeparatorCompute(totalStatistics.numMachines || 0)
            "
          >
            {{
              (totalStatistics.numMachines || 0).toFixed(0) | toThousandFilter
            }}
          </div>
        </div>
      </div>
      <div class="left-part-second">
        <TitleSlot
          :title="`${statisticsYear}年机具补贴情况`"
          :width="466"
          :contentHeight="252"
          backgroundImageSize="header-img-466"
          :noHeaderMargin="true"
        >
          <LeftSecond
            :machinerySubsidyList="machinerySubsidyList"
            v-if="machinerySubsidyList.length > 0"
          ></LeftSecond>
          <div v-else class="empty_panel"></div>
        </TitleSlot>
      </div>
      <div class="left-part-third">
        <TitleSlot
          :title="`${statisticsYear}年补贴数量前五名机具`"
          :width="466"
          :contentHeight="200"
          backgroundImageSize="header-img-466"
          :noHeaderMargin="true"
        >
          <LeftThird :machinerySubsidyRank="machinerySubsidyRank"></LeftThird>
        </TitleSlot>
      </div>
      <div :class="[leftFourthData.years.length > 0 ? 'left-part-fourth' : '']">
        <TitleSlot
          :title="`历年补贴资金规模`"
          :width="466"
          :contentHeight="162"
          backgroundImageSize="header-img-489"
          :noHeaderMargin="true"
        >
          <LeftFourth
            :chartData="leftFourthData"
            v-if="leftFourthData.years.length > 0"
            :max="leftFourthMax"
            :min="leftFourthMin"
          ></LeftFourth>
          <div v-else class="empty_panel"></div>
        </TitleSlot>
      </div>
    </div>
    <div class="center-part" id="purchaseAllowanceCenterPart">
      <div class="select_left">
        <div class="label">统计年份</div>
        <el-select
          size="mini"
          v-model.trim="statisticsYear"
          placeholder=""
          class="work_select year_panel"
        >
          <el-option
            v-for="item in yearOptions"
            :key="item.text"
            :label="item.text"
            :value="item.text"
          ></el-option>
        </el-select>
      </div>
      <!-- 资金使用率、兑付率切换 -->
      <!-- <div class="switch-box">
        <div
          class="use"
          :class="[activeValue == '-1' ? 'active' : '']"
          @click="activeValue = '-1'"
        >
          <img
            :src="
              require(`../../../assets/images/governmentAffairs/purchaseAllowance/map/icon_map_${
                activeValue == '-1' ? 'sy_c' : 'sy'
              }.png`)
            "
          />
          <div class="use-box">
            <div class="use-title" data-content="使用率">使用率</div>
          </div>
        </div>
        <div
          class="cash"
          :class="[activeValue == '-2' ? 'active' : '']"
          @click="activeValue = '-2'"
        >
          <img
            :src="
              require(`../../../assets/images/governmentAffairs/purchaseAllowance/map/icon_map_${
                activeValue == '-2' ? 'df_c' : 'df'
              }.png`)
            "
          />
          <div class="use-box">
            <div class="use-title" data-content="兑付率">兑付率</div>
          </div>
        </div>
      </div>
      <img
        id="purchaseAllowanceLegend"
        class="legend"
        :src="
          require(`../../../assets/images/governmentAffairs/purchaseAllowance/map/legend-${
            activeValue == '-1' ? 'sy' : 'df'
          }.png`)
        "
      /> -->
    </div>
    <div class="right-part">
      <div class="right-part-first">
        <div class="statistics-right">
          <div class="statistics-right-title">中央资金使用(万元)</div>
          <div
            class="statistics-right-number"
            :data-content="
              numberFloatSeparatorCompute(totalStatistics.centralSubsidy || 0)
            "
          >
            {{ totalStatistics.centralSubsidy || 0 | toThousandFloatFilter }}
          </div>
        </div>
        <div class="statistics-right">
          <div class="statistics-right-title">中央资金结算(万元)</div>
          <div
            class="statistics-right-number"
            :data-content="
              numberFloatSeparatorCompute(
                totalStatistics.centralSubsidySettlement || 0
              )
            "
          >
            {{
              totalStatistics.centralSubsidySettlement ||
              0 | toThousandFloatFilter
            }}
          </div>
        </div>
      </div>
      <div class="right-part-second">
        <TitleSlot
          :title="`${statisticsYear}年资金使用量前五名机具`"
          :width="464"
          :contentHeight="256"
          backgroundImageSize="header-img-466"
          :noHeaderMargin="true"
        >
          <RightSecond
            :fundRank="fundRank"
            v-if="fundRank.length > 0"
          ></RightSecond>
          <div v-else class="empty_panel"></div>
        </TitleSlot>
      </div>
      <div class="right-part-third">
        <div class="chosed-div">
          <el-select
            v-model.trim="useSelected"
            placeholder=""
            class="use-select"
            popper-class="government-affairs-select-popper use-select"
          >
            <el-option
              v-for="item in types"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            v-model.trim="monthSelected"
            placeholder=""
            class="month-select"
            popper-class="government-affairs-select-popper"
          >
            <el-option
              v-for="item in monthOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <TitleSlot
          :title="`年度各月数据同环比`"
          :width="464"
          :contentHeight="204"
          backgroundImageSize="header-img-466"
          :noHeaderMargin="true"
        >
          <RightThird
            :useSelected="useSelected"
            :monthSelected="monthSelected"
            @switchClcik="switchClcik"
            :chartData="rightThirdData"
          ></RightThird>
        </TitleSlot>
      </div>
      <div :class="[rightFourthData.length > 0 ? 'right-part-fourth' : '']">
        <TitleSlot
          :title="`年度各月资金使用兑付情况`"
          :width="498"
          :contentHeight="160"
          backgroundImageSize="header-img-489"
          :noHeaderMargin="true"
        >
          <RightFourth
            :chartData="rightFourthData"
            v-if="rightFourthData.length > 0"
          ></RightFourth>
          <div v-else class="empty_panel"></div>
        </TitleSlot>
      </div>
    </div>
    <ChosePage class="chose-page"></ChosePage>
    <!-- 地图 -->
    <div class="map_container">
      <MapModel
        ref="mapModel"
        :areaUsedList="areaUsedList"
        :rectBounds="rectBounds"
      />
    </div>
  </div>
</template>

<script>
import * as purchaseAllowanceApi from "@/api/governmentAffairs/purchaseAllowance.js";
import { mapGetters } from "vuex";
import TitleSlot from "../components/TitleSlot";
import LeftSecond from "./components/LeftSecond";
import LeftThird from "./components/LeftThird";
import LeftFourth from "./components/LeftFourth";
import RightSecond from "./components/RightSecond";
import RightThird from "./components/RightThird";
import RightFourth from "./components/RightFourth";
import MapModel from "./components/MapModel";
import ChosePage from "../components/ChosePage";

export default {
  components: {
    TitleSlot,
    LeftSecond,
    LeftThird,
    LeftFourth,
    RightSecond,
    RightThird,
    RightFourth,
    MapModel,
    ChosePage,
  },
  data() {
    return {
      commonParams: {
        year: "2024",
      },
      // 使用率、兑付率
      // activeValue: "-1",
      // 顶部5项数据
      totalStatistics: {
        // 申请表数(份)
        numApplications: 0,
        // 收益户数
        numBeneficiaries: 0,
        // 补贴机具台数
        numMachines: 0,
        // 中央资金使用
        centralSubsidy: 0,
        // 中央资金结算
        centralSubsidySettlement: 0,
      },
      statisticsYear: new Date().getFullYear(),
      // 机具补贴情况
      machinerySubsidyList: [],
      // 补贴数量前五名机具
      machinerySubsidyRank: [],
      // 历年补贴资金规模
      leftFourthData: {
        years: [],
        num: [],
      },
      // 年度各月数据同环比
      rightThirdData: {
        yearAndMonth: [],
        years: [],
        months: [],
        dataList: [],
        ratio: "",
      },
      // 类型  同比1、环比切换2
      ratioType: 1,
      // 资金使用量前五名机具
      fundRank: [],
      // 年度各月资金使用兑付情况
      rightFourthData: [],
      // 各区域使用率兑付率
      areaUsedList: [],
      // 被选中月份
      monthSelected: 1,
      // 使用率被选中
      useSelected: 0,
      //使用率、兑付率
      types: [
        {
          value: 0,
          label: "使用率",
        },
        {
          value: 1,
          label: "兑付率",
        },
      ],
      yearOptions: [],
      // 月份下拉
      monthOptions: [
        { value: 1, label: "1月" },
        { value: 2, label: "2月" },
        { value: 3, label: "3月" },
        { value: 4, label: "4月" },
        { value: 5, label: "5月" },
        { value: 6, label: "6月" },
        { value: 7, label: "7月" },
        { value: 8, label: "8月" },
        { value: 9, label: "9月" },
        { value: 10, label: "10月" },
        { value: 11, label: "11月" },
        { value: 12, label: "12月" },
      ],
      // 历年补贴资金规模 最大值
      leftFourthMax: 10,
      // 历年补贴资金规模 最小值
      leftFourthMin: 0,
      // 地图弹窗边界
      rectBounds: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
      },
    };
  },
  watch: {
    $route: {
      deep: true,
      handler(newVal, oldVal) {
        this.monthSelected = 1;
        this.useSelected = 0;
        // this.activeValue = "-1";
      },
    },
    "$store.state.activeRegionObj": {
      deep: true,
      immediate: true,
      handler(val) {
        if (!val.areaCode) return;
        this.isProvinceLevel = val.areaCode == "410000000";
        this.commonParams.year = this.$store.state.activeYear;
        this.initPageData();
        this.getLastUpdateTime();
        // const city = val.areaCode.slice(0, -3);
        this.$nextTick(() => {
          if (this.$refs.mapModel) {
            this.$refs.mapModel.addProvince(val.areaCode);
          }
        });
      },
    },
    statisticsYear: {
      // deep: true,
      immediate: true,
      handler(val) {
        this.commonParams.year = val;
        this.initPageData();
        if (!this.$store.state.activeRegionObj.areaCode) return;
        // const city = this.$store.state.activeRegionObj.areaCode.slice(0, -3);
        this.$nextTick(() => {
          if (this.$refs.mapModel) {
            this.$refs.mapModel.addProvince(
              this.$store.state.activeRegionObj.areaCode
            );
          }
        });
      },
    },
    // 月份选择
    monthSelected: {
      deep: true,
      immediate: true,
      handler(val) {
        if (this.ratioType == 1) {
          this.getLastYearRatio();
        } else {
          this.getLastMonthRatio();
        }
      },
    },
    // 0使用率、 1兑付率
    useSelected: {
      deep: true,
      handler(val) {
        if (this.ratioType == 1) {
          this.getLastYearRatio();
        } else {
          this.getLastMonthRatio();
        }
      },
    },
  },
  computed: {
    numberSeparatorCompute() {
      return function (number) {
        let regex = /(?!^)(?=(\d{3})+(\.|$))/g;
        if (!number) {
          return 0;
        } else {
          return number.toFixed().replace(regex, ",");
        }
      };
    },
    numberFloatSeparatorCompute() {
      return function (number) {
        return number.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      };
    },
  },
  mounted() {
    this.$nextTick(() => {
      let el = document.getElementById("purchaseAllowanceCenterPart");
      if (!el) {
        return;
      }
      let centerRectBounds = document
        .getElementById("purchaseAllowanceCenterPart")
        .getBoundingClientRect();
      this.rectBounds = {
        // 获取左侧边界
        left: centerRectBounds.left,
        // 获取顶部边界
        top: centerRectBounds.top,
      };
      let chosePageBoxRectBounds = document
        .getElementById("chosePageBox")
        .getBoundingClientRect();
      this.rectBounds.bottom = chosePageBoxRectBounds.top;
      let legendRectBounds = document
        .getElementById("purchaseAllowanceLegend")
        .getBoundingClientRect();
      this.rectBounds.right = legendRectBounds.left;
    });
    const currentYear = new Date().getFullYear();
    for (let year = currentYear; year >= 2022; year--) {
      this.yearOptions.push({
        text: year,
      });
    }
    //this.initPageData();
    // this.getLastUpdateTime();
  },
  name: "purchaseAllowance",
  methods: {
    initPageData() {
      this.getStatistic();
      this.getMachinerySubsidyList();
      this.getMachinerySubsidyRank();
      this.getSubsidyByYear();
      this.getSubsidyTop();
      this.getSubsidyUseByYear();
      this.getAreaUsed();
      if (this.ratioType == 1) {
        this.getLastYearRatio();
      } else {
        this.getLastMonthRatio();
      }
    },
    //获取最后一次跟新时间
    getLastUpdateTime() {
      purchaseAllowanceApi.getLastUpdateTime("BT").then((res) => {
        this.$store.dispatch("setLastUpdateTime", res || "");
      });
    },
    // 年度各月数据同环比 1同比、 2环比
    switchClcik(type) {
      this.ratioType = type;
      if (type == 1) {
        this.getLastYearRatio();
      } else {
        this.getLastMonthRatio();
      }
    },
    // 仪表盘-各区域年度补贴机具数量统计 (顶部6项数据)
    getStatistic() {
      purchaseAllowanceApi.getStatistic(this.commonParams).then((res) => {
        this.totalStatistics = res;
      });
    },
    // 机具补贴情况
    getMachinerySubsidyList() {
      purchaseAllowanceApi
        .getMachinerySubsidyList(this.commonParams)
        .then((res) => {
          this.machinerySubsidyList = res || [];
        });
    },
    // 补贴数量前五名机具
    getMachinerySubsidyRank() {
      purchaseAllowanceApi
        .getMachinerySubsidyRank(this.commonParams)
        .then((res) => {
          this.machinerySubsidyRank = res || [];
        });
    },
    // 历年补贴资金规模
    getSubsidyByYear() {
      purchaseAllowanceApi.getSubsidyByYear(this.commonParams).then((res) => {
        let result = res || [];
        let max = 10;
        this.leftFourthData = {
          years: [],
          num: [],
        };
        result.forEach((item) => {
          this.leftFourthData.years.push(item.year);
          this.leftFourthData.num.push(item.centralFund);
        });
        max = Math.max(...this.leftFourthData.num);
        let nums = this.leftFourthData.num;
        if (max != 0) {
          for (let i = 0; i < nums.length; i++) {
            if (nums[i] == 0) {
              nums[i] = 0.01;
            }
          }
        } else {
          max = 10;
        }
        this.leftFourthMax = Math.round(max * 1.1);
      });
    },
    // 资金使用量前五名机具
    getSubsidyTop() {
      purchaseAllowanceApi.getSubsidyTop(this.commonParams).then((res) => {
        this.fundRank = res || [];
      });
    },
    // 转换数据为所需数据
    turnData(data) {
      if (data) {
        let currentYear = data?.currentYear;
        let currentMonth =
          data?.currentMonth < 10
            ? "0" + data?.currentMonth
            : data?.currentMonth;
        let passedYear = data?.passedYear;
        let passedMonth =
          data?.passedMonth < 10 ? "0" + data?.passedMonth : data?.passedMonth;
        this.rightThirdData.yearAndMonth = [
          passedYear + "." + passedMonth,
          currentYear + "." + currentMonth,
        ];
        this.rightThirdData.years = [passedYear, currentYear];
        this.rightThirdData.months = [passedMonth, currentMonth];
        this.rightThirdData.dataList = [data.passedData, data.currentData];
      }
    },
    // 年度各月数据同比
    getLastYearRatio() {
      purchaseAllowanceApi
        .getLastYearRatio({ ...this.commonParams, month: this.monthSelected })
        .then((res) => {
          if (!res) {
            return;
          }
          // 0使用率、 1兑付率
          if (this.useSelected == 1) {
            this.turnData(res?.settlementData);
            this.rightThirdData.ratio = res?.settlementRatio;
          } else {
            this.turnData(res?.useData);
            this.rightThirdData.ratio = res?.useRatio;
          }
        });
    },
    // 年度各月数据环比
    getLastMonthRatio() {
      purchaseAllowanceApi
        .getLastMonthRatio({ ...this.commonParams, month: this.monthSelected })
        .then((res) => {
          if (!res) {
            return;
          }
          // 0使用率、 1兑付率
          if (this.useSelected == 1) {
            this.turnData(res?.settlementData);
            this.rightThirdData.ratio = res?.settlementRatio;
          } else {
            this.turnData(res?.useData);
            this.rightThirdData.ratio = res?.useRatio;
          }
        });
    },
    // 年度各月资金使用兑付情况
    getSubsidyUseByYear() {
      purchaseAllowanceApi
        .getSubsidyUseByYear(this.commonParams)
        .then((res) => {
          this.rightFourthData = res || [];
        });
    },
    // 各区域使用率兑付率
    getAreaUsed() {
      purchaseAllowanceApi.getAreaMachineInfo(this.commonParams).then((res) => {
        this.$set(this, "areaUsedList", res);
      });
    },
  },
};
</script>
<style scoped lang="scss">
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}
.purchase-allowance {
  margin-top: vh(-35);
}
::v-deep.left-part {
  width: vw(512);
  margin-left: vw(10);
  z-index: 100;
  .left-part-first {
    display: flex;
    align-items: center;
    width: vw(488);
    height: vh(92);
    margin-left: vw(6);
    padding: 0 vw(20);
    background-image: url("../../../assets/images/governmentAffairs/purchaseAllowance/bg_bata.png");
    background-size: vw(488) vh(92);
    background-repeat: no-repeat;
    font-family: Microsoft YaHei;
    font-size: fontSize(14);
    color: #ffffff;
    .statistics {
      margin-right: vw(56);
      .statistics-title {
        width: vw(107);
        height: vh(24);
        line-height: vh(24);
        padding-left: vw(10);
        background-image: url("../../../assets/images/governmentAffairs/purchaseAllowance/bg_num.png");
      }
      .statistics-number {
        position: relative;
        margin-top: vh(6);
        margin-left: vw(10);
        font-family: Rajdhani;
        font-size: fontSize(26);
        font-style: italic;
      }
      .statistics-number::before {
        content: attr(data-content);
        position: absolute;
        top: 0;
        left: 0;
        color: transparent;
        text-shadow: 0 0 15px rgba(82, 242, 136, 1); /* 第四层阴影 */
      }
      .statistics-number::after {
        content: attr(data-content);
        position: absolute;
        top: 0;
        left: 0;
        color: transparent;
        background: linear-gradient(180deg, #ffffff 50%, #bdffcc 60%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }
  .left-part-fourth {
    background: url("../../../assets/images/governmentAffairs/purchaseAllowance/pic_chart_dzs.png")
      no-repeat;
    background-position: 40% 88%;
    background-size: 80%;
  }
}
::v-deep {
  .year_panel {
    width: vw(84);
    padding: 0;
    .el-input__inner {
      padding: 0 vw(20) 0 vw(18);
      height: vh(28);
      line-height: vh(28);
      text-align: left;
    }
    .el-input__suffix {
      right: vw(10);
    }
  }
}
.center-part {
  flex: 1;
  position: relative;
  .select_left {
    display: flex;
    position: absolute;
    top: vh(30);
    left: vw(170);
    z-index: 10;
    border-radius: vw(4);
    background-color: #0a441f;
    border: 1px solid #7dab83;
    .label {
      width: vw(72);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: fontSize(14);
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      background-color: #2f7b5f;
      border-top-left-radius: vw(4);
      border-bottom-left-radius: vw(4);
    }
  }
  .switch-box {
    z-index: 10;
    position: absolute;
    bottom: vh(180);
    left: vw(-20);
    .use,
    .cash {
      width: vw(153);
      height: vh(58);
      background: url("../../../assets/images/governmentAffairs/purchaseAllowance/map/btn_map.png")
        no-repeat;
      background-size: 100%;
      position: relative;
      img {
        position: absolute;
        bottom: 0;
        left: 0;
        width: vw(46);
        height: vh(46);
      }
      .use-box {
        position: absolute;
        bottom: vh(12);
        left: vw(50);
        color: #ffffff;
        .use-title {
          position: relative;
          font-style: italic;
          font-size: fontSize(18);
        }
        .use-title::before {
          position: absolute;
          content: attr(data-content); /* 使用伪元素复制文本 */
          color: transparent;
          text-shadow: none;
          width: vw(60);
          background: linear-gradient(
            180deg,
            #ffffff 0%,
            #ffffff 40%,
            #6bb689 100%
          );
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
    }
    .active {
      background: url("../../../assets/images/governmentAffairs/purchaseAllowance/map/btn_map_c.png")
        no-repeat;
      background-size: 100%;
      .use-box {
        position: absolute;
        bottom: vh(12);
        left: vw(50);
        color: transparent;
        .use-title {
          position: relative;
          font-weight: bold;
          font-style: italic;
          font-size: fontSize(18);
          text-shadow: 0 2px 0 rgba(36, 24, 0, 0.69);
        }
        .use-title::before {
          position: absolute;
          content: attr(data-content); /* 使用伪元素复制文本 */
          color: transparent;
          text-shadow: none;
          width: vw(60);
          background: linear-gradient(
            180deg,
            #ffffff 0%,
            #ffffff 40%,
            #ab8f54 100%
          );
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
    }
  }
  .legend {
    position: absolute;
    bottom: vh(175);
    right: vw(4);
    width: vw(92);
    height: vh(183);
    z-index: 10;
  }
}

.chose-page {
  position: absolute;
  bottom: vh(92);
  left: vw(785);
  width: vw(423);
  height: vh(116);
  z-index: 10;
}

.map_container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  width: 100%;
  background: url("../../../assets/images/governmentAffairs/purchaseAllowance/bg.gif")
    no-repeat;
  background-size: 100% 100%;
}

.right-part {
  width: vw(505);
  margin-right: vw(8);
  z-index: 100;
  position: relative;
  .right-part-first {
    display: flex;
    align-items: center;
    width: vw(488);
    height: vh(90);
    padding: 0 vw(20);
    background-image: url("../../../assets/images/governmentAffairs/purchaseAllowance/bg_bata.png");
    background-size: vw(488) vh(92);
    background-repeat: no-repeat;
    font-family: Microsoft YaHei;
    font-size: fontSize(14);
    color: #ffffff;
    .statistics-right {
      flex: 1;
      .statistics-right-title {
        width: vw(140);
        height: vh(24);
        line-height: vh(24);
        padding-left: vw(10);
        background-image: url("../../../assets/images/governmentAffairs/purchaseAllowance/bg_num.png");
      }
      .statistics-right-number {
        position: relative;
        margin-top: vh(6);
        margin-left: vw(10);
        font-size: fontSize(26);
        font-style: italic;
        font-family: Rajdhani;
      }
      .statistics-right-number::before {
        content: attr(data-content);
        position: absolute;
        top: 0;
        left: 0;
        color: transparent;
        text-shadow: 0 0 15px rgba(82, 242, 136, 1); /* 第四层阴影 */
      }
      .statistics-right-number::after {
        content: attr(data-content);
        position: absolute;
        top: 0;
        left: 0;
        color: transparent;
        background: linear-gradient(180deg, #ffffff 50%, #bdffcc 60%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }
  .right-part-second {
    padding-left: vw(22);
  }
  .right-part-third {
    position: relative;
    padding-left: vw(22);
    background: url("../../../assets/images/governmentAffairs/purchaseAllowance/pic_chart_dz.png")
      no-repeat;
    background-position: 60% 100%;
    background-size: 90%;
    .chosed-div {
      position: absolute;
      top: vh(26);
      right: vw(26);
      .month-select {
        width: vw(73);
      }
      .use-select {
        width: vw(93);
      }
    }
  }
  .right-part-fourth {
    background: url("../../../assets/images/governmentAffairs/purchaseAllowance/pic_chart_dzs_line.png")
      no-repeat;
    background-position: 76% 88%;
    background-size: 89%;
  }
}
</style>
